module.exports = __webpack_public_path__ + "img/error.4ff797b1.png";